import React, { useState } from "react";
import "../styles/Home.css";
import logo from "../assets/travelkariyelogo.webp";
import heroImage from "../assets/ladakhback.webp";
import thumb1 from "../assets/chandratal1.webp";
import thumb2 from "../assets/darjeeling1.webp";
import thumb3 from "../assets/nicobar.webp";
import thumb4 from "../assets/jaisalmer.webp";
import Swal from "sweetalert2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaPlane,
  FaSpinner,
  FaChevronUp,
  FaChevronDown,
} from "react-icons/fa";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaUserCircle,
} from "react-icons/fa";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// Pre-configured airport mapping for Booking COM API
const AIRPORTS = [
  // =========================
  // INDIA
  // =========================

  { label: "Delhi (DEL)", id: "DEL.AIRPORT" },
  { label: "Mumbai (BOM)", id: "BOM.AIRPORT" },
  { label: "Bengaluru (BLR)", id: "BLR.AIRPORT" },
  { label: "Chennai (MAA)", id: "MAA.AIRPORT" },
  { label: "Hyderabad (HYD)", id: "HYD.AIRPORT" },
  { label: "Kolkata (CCU)", id: "CCU.AIRPORT" },
  { label: "Ahmedabad (AMD)", id: "AMD.AIRPORT" },
  { label: "Goa (GOI)", id: "GOI.AIRPORT" },
  { label: "Pune (PNQ)", id: "PNQ.AIRPORT" },
  { label: "Jaipur (JAI)", id: "JAI.AIRPORT" },
  { label: "Lucknow (LKO)", id: "LKO.AIRPORT" },
  { label: "Kochi (COK)", id: "COK.AIRPORT" },
  { label: "Srinagar (SXR)", id: "SXR.AIRPORT" },
  { label: "Chandigarh (IXC)", id: "IXC.AIRPORT" },
  { label: "Amritsar (ATQ)", id: "ATQ.AIRPORT" },
  { label: "Bhopal (BHO)", id: "BHO.AIRPORT" },
  { label: "Indore (IDR)", id: "IDR.AIRPORT" },
  { label: "Nagpur (NAG)", id: "NAG.AIRPORT" },
  { label: "Surat (STV)", id: "STV.AIRPORT" },
  { label: "Vadodara (BDQ)", id: "BDQ.AIRPORT" },
  { label: "Rajkot (HSR)", id: "HSR.AIRPORT" },
  { label: "Udaipur (UDR)", id: "UDR.AIRPORT" },
  { label: "Jodhpur (JDH)", id: "JDH.AIRPORT" },
  { label: "Varanasi (VNS)", id: "VNS.AIRPORT" },
  { label: "Patna (PAT)", id: "PAT.AIRPORT" },
  { label: "Ranchi (IXR)", id: "IXR.AIRPORT" },
  { label: "Bhubaneswar (BBI)", id: "BBI.AIRPORT" },
  { label: "Guwahati (GAU)", id: "GAU.AIRPORT" },
  { label: "Bagdogra (IXB)", id: "IXB.AIRPORT" },
  { label: "Siliguri (IXB)", id: "IXB.AIRPORT" },
  { label: "Dehradun (DED)", id: "DED.AIRPORT" },
  { label: "Leh (IXL)", id: "IXL.AIRPORT" },
  { label: "Jammu (IXJ)", id: "IXJ.AIRPORT" },
  { label: "Aurangabad (IXU)", id: "IXU.AIRPORT" },
  { label: "Nashik (ISK)", id: "ISK.AIRPORT" },
  { label: "Coimbatore (CJB)", id: "CJB.AIRPORT" },
  { label: "Madurai (IXM)", id: "IXM.AIRPORT" },
  { label: "Trivandrum (TRV)", id: "TRV.AIRPORT" },
  { label: "Mangalore (IXE)", id: "IXE.AIRPORT" },
  { label: "Kannur (CNN)", id: "CNN.AIRPORT" },
  { label: "Vijayawada (VGA)", id: "VGA.AIRPORT" },
  { label: "Visakhapatnam (VTZ)", id: "VTZ.AIRPORT" },
  { label: "Tirupati (TIR)", id: "TIR.AIRPORT" },
  { label: "Raipur (RPR)", id: "RPR.AIRPORT" },
  { label: "Jabalpur (JLR)", id: "JLR.AIRPORT" },
  { label: "Gwalior (GWL)", id: "GWL.AIRPORT" },
  { label: "Agra (AGR)", id: "AGR.AIRPORT" },
  { label: "Kanpur (KNU)", id: "KNU.AIRPORT" },
  { label: "Prayagraj (IXD)", id: "IXD.AIRPORT" },
  { label: "Bareilly (BEK)", id: "BEK.AIRPORT" },
  { label: "Port Blair (IXZ)", id: "IXZ.AIRPORT" },
  { label: "Pondicherry (PNY)", id: "PNY.AIRPORT" },

  // =========================
  // UNITED ARAB EMIRATES
  // =========================

  { label: "Dubai (DXB)", id: "DXB.AIRPORT" },
  { label: "Abu Dhabi (AUH)", id: "AUH.AIRPORT" },
  { label: "Sharjah (SHJ)", id: "SHJ.AIRPORT" },
  { label: "Ras Al Khaimah (RKT)", id: "RKT.AIRPORT" },
  { label: "Al Ain (AAN)", id: "AAN.AIRPORT" },

  // =========================
  // SINGAPORE
  // =========================

  { label: "Singapore (SIN)", id: "SIN.AIRPORT" },

  // =========================
  // THAILAND
  // =========================

  { label: "Bangkok Suvarnabhumi (BKK)", id: "BKK.AIRPORT" },
  { label: "Bangkok Don Mueang (DMK)", id: "DMK.AIRPORT" },
  { label: "Phuket (HKT)", id: "HKT.AIRPORT" },
  { label: "Chiang Mai (CNX)", id: "CNX.AIRPORT" },
  { label: "Krabi (KBV)", id: "KBV.AIRPORT" },
  { label: "Koh Samui (USM)", id: "USM.AIRPORT" },

  // =========================
  // MALAYSIA
  // =========================

  { label: "Kuala Lumpur (KUL)", id: "KUL.AIRPORT" },
  { label: "Penang (PEN)", id: "PEN.AIRPORT" },
  { label: "Langkawi (LGK)", id: "LGK.AIRPORT" },
  { label: "Kota Kinabalu (BKI)", id: "BKI.AIRPORT" },
  { label: "Johor Bahru (JHB)", id: "JHB.AIRPORT" },

  // =========================
  // INDONESIA
  // =========================

  { label: "Bali / Denpasar (DPS)", id: "DPS.AIRPORT" },
  { label: "Jakarta (CGK)", id: "CGK.AIRPORT" },
  { label: "Surabaya (SUB)", id: "SUB.AIRPORT" },
  { label: "Medan (KNO)", id: "KNO.AIRPORT" },
  { label: "Lombok (LOP)", id: "LOP.AIRPORT" },

  // =========================
  // MALDIVES
  // =========================

  { label: "Male (MLE)", id: "MLE.AIRPORT" },
  { label: "Gan Island (GAN)", id: "GAN.AIRPORT" },

  // =========================
  // SRI LANKA
  // =========================

  { label: "Colombo (CMB)", id: "CMB.AIRPORT" },
  { label: "Mattala (HRI)", id: "HRI.AIRPORT" },

  // =========================
  // NEPAL
  // =========================

  { label: "Kathmandu (KTM)", id: "KTM.AIRPORT" },
  { label: "Pokhara (PKR)", id: "PKR.AIRPORT" },
  { label: "Bhairahawa (BWA)", id: "BWA.AIRPORT" },

  // =========================
  // BHUTAN
  // =========================

  { label: "Paro (PBH)", id: "PBH.AIRPORT" },

  // =========================
  // BANGLADESH
  // =========================

  { label: "Dhaka (DAC)", id: "DAC.AIRPORT" },
  { label: "Chittagong (CGP)", id: "CGP.AIRPORT" },
  { label: "Sylhet (ZYL)", id: "ZYL.AIRPORT" },

  // =========================
  // QATAR
  // =========================

  { label: "Doha (DOH)", id: "DOH.AIRPORT" },

  // =========================
  // SAUDI ARABIA
  // =========================

  { label: "Riyadh (RUH)", id: "RUH.AIRPORT" },
  { label: "Jeddah (JED)", id: "JED.AIRPORT" },
  { label: "Dammam (DMM)", id: "DMM.AIRPORT" },
  { label: "Medina (MED)", id: "MED.AIRPORT" },

  // =========================
  // OMAN
  // =========================

  { label: "Muscat (MCT)", id: "MCT.AIRPORT" },
  { label: "Salalah (SLL)", id: "SLL.AIRPORT" },

  // =========================
  // BAHRAIN
  // =========================

  { label: "Bahrain (BAH)", id: "BAH.AIRPORT" },

  // =========================
  // KUWAIT
  // =========================

  { label: "Kuwait City (KWI)", id: "KWI.AIRPORT" },

  // =========================
  // TURKEY
  // =========================

  { label: "Istanbul (IST)", id: "IST.AIRPORT" },
  { label: "Ankara (ESB)", id: "ESB.AIRPORT" },
  { label: "Antalya (AYT)", id: "AYT.AIRPORT" },
  { label: "Izmir (ADB)", id: "ADB.AIRPORT" },

  // =========================
  // UNITED KINGDOM
  // =========================

  { label: "London Heathrow (LHR)", id: "LHR.AIRPORT" },
  { label: "London Gatwick (LGW)", id: "LGW.AIRPORT" },
  { label: "Manchester (MAN)", id: "MAN.AIRPORT" },
  { label: "Birmingham (BHX)", id: "BHX.AIRPORT" },
  { label: "Edinburgh (EDI)", id: "EDI.AIRPORT" },
  { label: "Glasgow (GLA)", id: "GLA.AIRPORT" },

  // =========================
  // FRANCE
  // =========================

  { label: "Paris Charles de Gaulle (CDG)", id: "CDG.AIRPORT" },
  { label: "Paris Orly (ORY)", id: "ORY.AIRPORT" },
  { label: "Nice (NCE)", id: "NCE.AIRPORT" },
  { label: "Lyon (LYS)", id: "LYS.AIRPORT" },

  // =========================
  // GERMANY
  // =========================

  { label: "Frankfurt (FRA)", id: "FRA.AIRPORT" },
  { label: "Munich (MUC)", id: "MUC.AIRPORT" },
  { label: "Berlin (BER)", id: "BER.AIRPORT" },
  { label: "Hamburg (HAM)", id: "HAM.AIRPORT" },

  // =========================
  // ITALY
  // =========================

  { label: "Rome (FCO)", id: "FCO.AIRPORT" },
  { label: "Milan (MXP)", id: "MXP.AIRPORT" },
  { label: "Venice (VCE)", id: "VCE.AIRPORT" },

  // =========================
  // SPAIN
  // =========================

  { label: "Madrid (MAD)", id: "MAD.AIRPORT" },
  { label: "Barcelona (BCN)", id: "BCN.AIRPORT" },
  { label: "Palma de Mallorca (PMI)", id: "PMI.AIRPORT" },

  // =========================
  // NETHERLANDS
  // =========================

  { label: "Amsterdam (AMS)", id: "AMS.AIRPORT" },

  // =========================
  // SWITZERLAND
  // =========================

  { label: "Zurich (ZRH)", id: "ZRH.AIRPORT" },
  { label: "Geneva (GVA)", id: "GVA.AIRPORT" },

  // =========================
  // AUSTRIA
  // =========================

  { label: "Vienna (VIE)", id: "VIE.AIRPORT" },

  // =========================
  // USA
  // =========================

  { label: "New York JFK (JFK)", id: "JFK.AIRPORT" },
  { label: "New York Newark (EWR)", id: "EWR.AIRPORT" },
  { label: "Los Angeles (LAX)", id: "LAX.AIRPORT" },
  { label: "San Francisco (SFO)", id: "SFO.AIRPORT" },
  { label: "Chicago (ORD)", id: "ORD.AIRPORT" },
  { label: "Miami (MIA)", id: "MIA.AIRPORT" },
  { label: "Boston (BOS)", id: "BOS.AIRPORT" },
  { label: "Washington DC (IAD)", id: "IAD.AIRPORT" },
  { label: "Atlanta (ATL)", id: "ATL.AIRPORT" },
  { label: "Dallas (DFW)", id: "DFW.AIRPORT" },
  { label: "Houston (IAH)", id: "IAH.AIRPORT" },
  { label: "Seattle (SEA)", id: "SEA.AIRPORT" },
  { label: "Las Vegas (LAS)", id: "LAS.AIRPORT" },
  { label: "Orlando (MCO)", id: "MCO.AIRPORT" },

  // =========================
  // CANADA
  // =========================

  { label: "Toronto (YYZ)", id: "YYZ.AIRPORT" },
  { label: "Vancouver (YVR)", id: "YVR.AIRPORT" },
  { label: "Montreal (YUL)", id: "YUL.AIRPORT" },
  { label: "Calgary (YYC)", id: "YYC.AIRPORT" },

  // =========================
  // AUSTRALIA
  // =========================

  { label: "Sydney (SYD)", id: "SYD.AIRPORT" },
  { label: "Melbourne (MEL)", id: "MEL.AIRPORT" },
  { label: "Brisbane (BNE)", id: "BNE.AIRPORT" },
  { label: "Perth (PER)", id: "PER.AIRPORT" },
  { label: "Adelaide (ADL)", id: "ADL.AIRPORT" },

  // =========================
  // JAPAN
  // =========================

  { label: "Tokyo Narita (NRT)", id: "NRT.AIRPORT" },
  { label: "Tokyo Haneda (HND)", id: "HND.AIRPORT" },
  { label: "Osaka Kansai (KIX)", id: "KIX.AIRPORT" },
  { label: "Nagoya (NGO)", id: "NGO.AIRPORT" },
  { label: "Fukuoka (FUK)", id: "FUK.AIRPORT" },

  // =========================
  // SOUTH KOREA
  // =========================

  { label: "Seoul Incheon (ICN)", id: "ICN.AIRPORT" },
  { label: "Seoul Gimpo (GMP)", id: "GMP.AIRPORT" },
  { label: "Busan (PUS)", id: "PUS.AIRPORT" },

  // =========================
  // CHINA
  // =========================

  { label: "Beijing (PEK)", id: "PEK.AIRPORT" },
  { label: "Shanghai Pudong (PVG)", id: "PVG.AIRPORT" },
  { label: "Guangzhou (CAN)", id: "CAN.AIRPORT" },
  { label: "Shenzhen (SZX)", id: "SZX.AIRPORT" },
  { label: "Chengdu (CTU)", id: "CTU.AIRPORT" },

  // =========================
  // HONG KONG
  // =========================

  { label: "Hong Kong (HKG)", id: "HKG.AIRPORT" },

  // =========================
  // NEW ZEALAND
  // =========================

  { label: "Auckland (AKL)", id: "AKL.AIRPORT" },
  { label: "Christchurch (CHC)", id: "CHC.AIRPORT" },

  // =========================
  // SOUTH AFRICA
  // =========================

  { label: "Johannesburg (JNB)", id: "JNB.AIRPORT" },
  { label: "Cape Town (CPT)", id: "CPT.AIRPORT" },
  { label: "Durban (DUR)", id: "DUR.AIRPORT" },

  // =========================
  // EGYPT
  // =========================

  { label: "Cairo (CAI)", id: "CAI.AIRPORT" },
  { label: "Sharm El Sheikh (SSH)", id: "SSH.AIRPORT" },

  // =========================
  // KENYA
  // =========================

  { label: "Nairobi (NBO)", id: "NBO.AIRPORT" },
  { label: "Mombasa (MBA)", id: "MBA.AIRPORT" },

  // =========================
  // MAURITIUS
  // =========================

  { label: "Mauritius (MRU)", id: "MRU.AIRPORT" },

  // =========================
  // SEYCHELLES
  // =========================

  { label: "Seychelles (SEZ)", id: "SEZ.AIRPORT" },

  // =========================
  // BRAZIL
  // =========================

  { label: "São Paulo (GRU)", id: "GRU.AIRPORT" },
  { label: "Rio de Janeiro (GIG)", id: "GIG.AIRPORT" },

  // =========================
  // MEXICO
  // =========================

  { label: "Mexico City (MEX)", id: "MEX.AIRPORT" },
  { label: "Cancun (CUN)", id: "CUN.AIRPORT" },

  // =========================
  // NETHERLANDS / CARIBBEAN
  // =========================

  { label: "Aruba (AUA)", id: "AUA.AIRPORT" },

  // =========================
  // IRELAND
  // =========================

  { label: "Dublin (DUB)", id: "DUB.AIRPORT" },

  // =========================
  // PORTUGAL
  // =========================

  { label: "Lisbon (LIS)", id: "LIS.AIRPORT" },
  { label: "Porto (OPO)", id: "OPO.AIRPORT" },

  // =========================
  // GREECE
  // =========================

  { label: "Athens (ATH)", id: "ATH.AIRPORT" },
  { label: "Santorini (JTR)", id: "JTR.AIRPORT" },

  // =========================
  // VIETNAM
  // =========================

  { label: "Ho Chi Minh City (SGN)", id: "SGN.AIRPORT" },
  { label: "Hanoi (HAN)", id: "HAN.AIRPORT" },
  { label: "Da Nang (DAD)", id: "DAD.AIRPORT" },

  // =========================
  // PHILIPPINES
  // =========================

  { label: "Manila (MNL)", id: "MNL.AIRPORT" },
  { label: "Cebu (CEB)", id: "CEB.AIRPORT" },

  // =========================
  // CAMBODIA
  // =========================

  { label: "Phnom Penh (PNH)", id: "PNH.AIRPORT" },
  { label: "Siem Reap (SAI)", id: "SAI.AIRPORT" },

  // =========================
  // MYANMAR
  // =========================

  { label: "Yangon (RGN)", id: "RGN.AIRPORT" },

  // =========================
  // NEPAL / HIMALAYAN REGION
  // =========================

  { label: "Kathmandu (KTM)", id: "KTM.AIRPORT" },

  // =========================
  // EUROPE
  // =========================

  { label: "Copenhagen (CPH)", id: "CPH.AIRPORT" },
  { label: "Stockholm (ARN)", id: "ARN.AIRPORT" },
  { label: "Oslo (OSL)", id: "OSL.AIRPORT" },
  { label: "Helsinki (HEL)", id: "HEL.AIRPORT" },
  { label: "Brussels (BRU)", id: "BRU.AIRPORT" },
  { label: "Prague (PRG)", id: "PRG.AIRPORT" },
  { label: "Budapest (BUD)", id: "BUD.AIRPORT" },
  { label: "Warsaw (WAW)", id: "WAW.AIRPORT" },
  { label: "Athens (ATH)", id: "ATH.AIRPORT" },
  { label: "Moscow (SVO)", id: "SVO.AIRPORT" },
  { label: "Zurich (ZRH)", id: "ZRH.AIRPORT" },

  // =========================
  // MIDDLE EAST
  // =========================

  { label: "Tel Aviv (TLV)", id: "TLV.AIRPORT" },
  { label: "Amman (AMM)", id: "AMM.AIRPORT" },
  { label: "Beirut (BEY)", id: "BEY.AIRPORT" },
  { label: "Baku (GYD)", id: "GYD.AIRPORT" },
  { label: "Tbilisi (TBS)", id: "TBS.AIRPORT" },
  { label: "Yerevan (EVN)", id: "EVN.AIRPORT" },
];

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // Lead Form State (Firebase)
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    from: "Delhi, India",
    to: "Goa, India",
    date: "",
  });

  // Booking COM Flight Search State
  const [flightData, setFlightData] = useState({
    fromId: "DXB.AIRPORT",
    toId: "BLR.AIRPORT",
    departDate: "2026-08-19",
  });
  const [flights, setFlights] = useState([]);
  const [loadingFlights, setLoadingFlights] = useState(false);
  const [flightError, setFlightError] = useState(null);
  const [isResultsMinimized, setIsResultsMinimized] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFlightChange = (e) => {
    setFlightData({
      ...flightData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle Lead Form Submission to Firestore
  const handleSubmit = async () => {
    if (!formData.name || !formData.mobile || !formData.date) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please fill all fields.",
        confirmButtonColor: "#18d4df",
      });
      return;
    }

    if (!/^\d{10}$/.test(formData.mobile)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number.",
        confirmButtonColor: "#18d4df",
      });
      return;
    }

    try {
      await addDoc(collection(db, "travelBookings"), {
        name: formData.name,
        mobile: formData.mobile,
        from: formData.from,
        to: formData.to,
        date: formData.date,
        createdAt: serverTimestamp(),
      });

      Swal.fire({
        icon: "success",
        title: "Booking Submitted!",
        text: "Thank you! Our travel expert will contact you shortly.",
        confirmButtonColor: "#18d4df",
        timer: 2500,
        showConfirmButton: false,
      });

      setFormData({
        name: "",
        mobile: "",
        from: "Delhi, India",
        to: "Goa, India",
        date: "",
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Please try again later.",
        confirmButtonColor: "#ff4d4f",
      });
    }
  };

  // Handle Flight Search API Call
  const handleFlightSearch = async (e) => {
    e.preventDefault();

    if (!flightData.departDate) {
      Swal.fire({
        icon: "warning",
        title: "Date Required",
        text: "Please select a flight date.",
        confirmButtonColor: "#18d4df",
      });
      return;
    }

    setLoadingFlights(true);
    setFlightError(null);
    setFlights([]);

    const queryParams = new URLSearchParams({
      fromId: flightData.fromId,
      toId: flightData.toId,
      departDate: flightData.departDate,
      adults: "1",
      children: "0",
      sort: "BEST",
      cabinClass: "ECONOMY",
      currency_code: "INR",
      pageNo: "1",
    });

    try {
      const response = await fetch(
        `https://booking-com15.p.rapidapi.com/api/v1/flights/searchFlights?${queryParams.toString()}`,
        {
          method: "GET",
          headers: {
            "x-rapidapi-key":
              process.env.REACT_APP_RAPIDAPI_KEY ||
              "82f0a2c073mshc80b6b4a96395cdp1led2bjsnae9413302238",
            "x-rapidapi-host": "booking-com15.p.rapidapi.com",
          },
        }
      );

      const result = await response.json();

      if (result.status && result.data) {
        const offers = result.data.flightOffers || result.data.offerData || [];
        setFlights(offers);
        setIsResultsMinimized(false);
        if (offers.length === 0) {
          setFlightError("No flights found for selected date and route.");
        }
      } else {
        setFlightError(result.message || "No flights found for selected parameters.");
      }
    } catch (err) {
      console.error("Flight Search Error:", err);
      setFlightError("Failed to fetch flight details. Please try again.");
    } finally {
      setLoadingFlights(false);
    }
  };

  // Redirect to Booking Page with selected flight state
  const handleSelectFlight = (flight) => {
    const price =
      flight.priceBreakdown?.total?.units ||
      flight.price?.formatted ||
      "N/A";
    const currency =
      flight.priceBreakdown?.total?.currencyCode || "INR";
    const carrierName =
      flight.legs?.[0]?.carriersData?.[0]?.name ||
      flight.segments?.[0]?.legs?.[0]?.carrierName ||
      "Flight Option";

    navigate("/booknow", {
      state: {
        flightDetails: {
          carrier: carrierName,
          from: flightData.fromId.split(".")[0],
          to: flightData.toId.split(".")[0],
          departDate: flightData.departDate,
          price: price,
          currency: currency,
          raw: flight,
        },
      },
    });
  };

  return (
    <div
      className="home-container"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      {/* Overlay */}
      <div className="home-overlay"></div>

      {/* Navbar */}
      <header className="home-header">
        <div className="home-logo">
          <img src={logo} alt="Logo" />
        </div>

        {/* Desktop Navigation */}
        <nav className="home-nav desktop-nav">
          <Link
            to="/"
            className={location.pathname === "/" ? "active-link" : ""}
          >
            Home
          </Link>
          <Link to="/packages">Packages</Link>

          <div className="dropdown">
            <span className="dropbtn">
              Destinations
              <FaChevronDown style={{ fontSize: "11px" }} />
            </span>

            <div className="dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
              <Link to="/abu">Abu Dhabi</Link>
              <Link to="/dubai">Dubai</Link>
            </div>
          </div>

          <Link to="/hotels">Hotels</Link>
          <Link to="/contact-us">Contact Us</Link>
        </nav>

        <Link to="/booknow" className="desktop-book">
          <button className="login-btn">
            <FaUserCircle />
            Book Now
          </button>
        </Link>

        {/* Hamburger */}
        <div className="menu-icon" onClick={() => setMenuOpen(true)}>
          <FaBars />
        </div>
      </header>

      <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>
        <div className="close-btn">
          <FaTimes onClick={() => setMenuOpen(false)} />
        </div>

        <Link to="/" onClick={() => setMenuOpen(false)}>
          Home
        </Link>
        <Link to="/packages" onClick={() => setMenuOpen(false)}>
          Packages
        </Link>
        <Link to="/goa" onClick={() => setMenuOpen(false)}>
          Goa
        </Link>
        <Link to="/kerala" onClick={() => setMenuOpen(false)}>
          Kerala
        </Link>
        <Link to="/rajasthan" onClick={() => setMenuOpen(false)}>
          Rajasthan
        </Link>
        <Link to="/hotels" onClick={() => setMenuOpen(false)}>
          Hotels
        </Link>
        <Link to="/contact-us" onClick={() => setMenuOpen(false)}>
          Contact Us
        </Link>
        <Link to="/booknow" onClick={() => setMenuOpen(false)}>
          <button className="login-btn mobile-book-btn">
            <FaUserCircle />
            Book Now
          </button>
        </Link>
      </div>

      {/* Social Bar */}
      <div className="social-bar">
        <a
          href="https://twitter.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
        >
          <FaTwitter />
        </a>
        <a
          href="https://facebook.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://instagram.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>
        <a
          href="https://youtube.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="YouTube"
        >
          <FaYoutube />
        </a>
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-left">
          <h2>Say yes</h2>
          <h1>
            TO YOUR
            <br />
            VACATION
          </h1>
          <p>
            Discover breathtaking destinations, luxury stays, and unforgettable
            travel experiences around the world.
          </p>
          <Link to="/learnmore">
            <button className="home-learn-btn">Learn More</button>
          </Link>
        </div>

        <div className="hero-gallery">
          <img src={thumb1} alt="Destination 1" />
          <img src={thumb2} alt="Destination 2" />
          <img src={thumb3} alt="Destination 3" />
          <img src={thumb4} alt="Destination 4" />
        </div>
      </section>

      {/* 1. Lead Capture Form */}
      <div className="search-box">
        <div className="field">
          <label>Name</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>Mobile Number</label>
          <input
            type="tel"
            name="mobile"
            placeholder="Enter mobile number"
            maxLength={10}
            value={formData.mobile}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>From</label>
          <select name="from" value={formData.from} onChange={handleChange}>
            <option value="">Select State / UT</option>
            <option>Andhra Pradesh</option>
            <option>Arunachal Pradesh</option>
            <option>Assam</option>
            <option>Bihar</option>
            <option>Chhattisgarh</option>
            <option>Goa</option>
            <option>Gujarat</option>
            <option>Haryana</option>
            <option>Himachal Pradesh</option>
            <option>Jharkhand</option>
            <option>Karnataka</option>
            <option>Kerala</option>
            <option>Madhya Pradesh</option>
            <option>Maharashtra</option>
            <option>Manipur</option>
            <option>Meghalaya</option>
            <option>Mizoram</option>
            <option>Nagaland</option>
            <option>Odisha</option>
            <option>Punjab</option>
            <option>Rajasthan</option>
            <option>Sikkim</option>
            <option>Tamil Nadu</option>
            <option>Telangana</option>
            <option>Tripura</option>
            <option>Uttar Pradesh</option>
            <option>Uttarakhand</option>
            <option>West Bengal</option>
            <option>Andaman and Nicobar Islands</option>
            <option>Chandigarh</option>
            <option>Dadra and Nagar Haveli and Daman and Diu</option>
            <option>Delhi</option>
            <option>Jammu and Kashmir</option>
            <option>Ladakh</option>
            <option>Lakshadweep</option>
            <option>Puducherry</option>
          </select>
        </div>

        <div className="field">
          <label>To</label>
          <select name="to" value={formData.to} onChange={handleChange}>
            <option value="">Select Destination</option>
            <option>Andhra Pradesh</option>
            <option>Arunachal Pradesh</option>
            <option>Assam</option>
            <option>Bihar</option>
            <option>Chhattisgarh</option>
            <option>Goa</option>
            <option>Gujarat</option>
            <option>Haryana</option>
            <option>Himachal Pradesh</option>
            <option>Jharkhand</option>
            <option>Karnataka</option>
            <option>Kerala</option>
            <option>Madhya Pradesh</option>
            <option>Maharashtra</option>
            <option>Manipur</option>
            <option>Meghalaya</option>
            <option>Mizoram</option>
            <option>Nagaland</option>
            <option>Odisha</option>
            <option>Punjab</option>
            <option>Rajasthan</option>
            <option>Sikkim</option>
            <option>Tamil Nadu</option>
            <option>Telangana</option>
            <option>Tripura</option>
            <option>Uttar Pradesh</option>
            <option>Uttarakhand</option>
            <option>West Bengal</option>
            <option>Andaman and Nicobar Islands</option>
            <option>Chandigarh</option>
            <option>Dadra and Nagar Haveli and Daman and Diu</option>
            <option>Delhi</option>
            <option>Jammu and Kashmir</option>
            <option>Ladakh</option>
            <option>Lakshadweep</option>
            <option>Puducherry</option>
            <option>Dubai</option>
            <option>Abu Dhabi</option>
            <option>Singapore</option>
            <option>Thailand</option>
            <option>Maldives</option>
            <option>Bali</option>
            <option>Vietnam</option>
            <option>Sri Lanka</option>
            <option>Nepal</option>
            <option>Bhutan</option>
          </select>
        </div>

        <div className="field">
          <label>Date</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />
        </div>

        <button className="search-btn" onClick={handleSubmit}>
          SUBMIT
        </button>
      </div>

      {/* 2. RapidAPI Flight Search Section */}
      <div className="flight-search-section">
        <div className="flight-search-card">
          <h3 className="flight-search-title">
            <FaPlane /> Flight Search
          </h3>

          <form onSubmit={handleFlightSearch} className="flight-search-form">
            <div className="flight-field">
              <label>From Airport</label>
              <select
                name="fromId"
                value={flightData.fromId}
                onChange={handleFlightChange}
              >
                {AIRPORTS.map((ap) => (
                  <option key={ap.id} value={ap.id}>
                    {ap.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flight-field">
              <label>To Airport</label>
              <select
                name="toId"
                value={flightData.toId}
                onChange={handleFlightChange}
              >
                {AIRPORTS.map((ap) => (
                  <option key={ap.id} value={ap.id}>
                    {ap.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flight-field">
              <label>Departure Date</label>
              <input
                type="date"
                name="departDate"
                value={flightData.departDate}
                onChange={handleFlightChange}
              />
            </div>

            <button
              type="submit"
              className="flight-search-btn"
              disabled={loadingFlights}
            >
              {loadingFlights ? (
                <FaSpinner className="spinner" />
              ) : (
                "SEARCH FLIGHTS"
              )}
            </button>
          </form>
        </div>

        {/* Flight Search Error Banner */}
        {flightError && <div className="flight-error-msg">{flightError}</div>}

        {/* Flight Results Wrapper */}
        {flights.length > 0 && (
          <div className="flight-results-wrapper">
            <div className="flight-results-header">
              <h4 className="flight-results-title">
                Available Flights ({flights.length})
              </h4>
              <button
                type="button"
                className="minimize-btn"
                onClick={() => setIsResultsMinimized(!isResultsMinimized)}
              >
                {isResultsMinimized ? (
                  <>
                    Expand List <FaChevronDown />
                  </>
                ) : (
                  <>
                    Minimize List <FaChevronUp />
                  </>
                )}
              </button>
            </div>

            {!isResultsMinimized && (
              <div className="flight-results-list">
                {flights.map((flight, idx) => {
                  const price =
                    flight.priceBreakdown?.total?.units ||
                    flight.price?.formatted ||
                    "N/A";
                  const currency =
                    flight.priceBreakdown?.total?.currencyCode || "INR";

                  const carrierName =
                    flight.legs?.[0]?.carriersData?.[0]?.name ||
                    flight.segments?.[0]?.legs?.[0]?.carrierName ||
                    "Flight Option";

                  return (
                    <div key={idx} className="flight-result-card">
                      <div>
                        <h5 className="flight-carrier-name">{carrierName}</h5>
                        <p className="flight-route-info">
                          Departure:{" "}
                          <strong>{flightData.fromId.split(".")[0]}</strong> →
                          Arrival:{" "}
                          <strong>{flightData.toId.split(".")[0]}</strong>
                        </p>
                      </div>

                      <div className="flight-price-container">
                        <span className="flight-price">
                          {currency} {price}
                        </span>
                        <br />
                        <button
                          className="flight-select-btn"
                          onClick={() => handleSelectFlight(flight)}
                        >
                          Select Flight
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;